var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "status_1_content" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.vLoading,
            expression: "vLoading"
          }
        ],
        staticClass: "status_1_content_content"
      },
      [
        _c("div", [
          _vm.currentValue.type == 3
            ? _c(
                "div",
                { staticClass: "contentItem questionMatter" },
                [
                  _c("question", { attrs: { questionId: _vm.currentValue.id } })
                ],
                1
              )
            : _vm.currentValue.type === 6
            ? _c(
                "div",
                { staticClass: "type6style" },
                _vm._l(_vm.currentValue.imageText, function(item, index) {
                  return item
                    ? _c(
                        "div",
                        {
                          key: index,
                          ref: "scroll" + item.sort,
                          refInFor: true,
                          staticClass: "type6Item",
                          style: item.style
                        },
                        [
                          item.type === 1
                            ? _c("div", {
                                staticClass:
                                  "editorShowArea ql-editor zl-editor",
                                domProps: { innerHTML: _vm._s(item.value) }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.type === 3 &&
                          (_vm.hasQuestionTypeId(item) == 1 ||
                            _vm.hasQuestionTypeId(item) == 2 ||
                            _vm.hasQuestionTypeId(item) == 3)
                            ? _c("answer", {
                                attrs: { answerList: _vm.answerList },
                                on: { submitAnswer: _vm.submitAnswer },
                                model: {
                                  value: item.valueObj.questionContent,
                                  callback: function($$v) {
                                    _vm.$set(
                                      item.valueObj,
                                      "questionContent",
                                      $$v
                                    )
                                  },
                                  expression: "item.valueObj.questionContent"
                                }
                              })
                            : item.type === 3
                            ? _c("operation", {
                                attrs: {
                                  item: item,
                                  questionId: item.value,
                                  questionTypeId: _vm.hasQuestionTypeId(item)
                                },
                                on: {
                                  handleGoStudy: _vm.handleGoStudy,
                                  addEventObj: _vm.addEventObj
                                }
                              })
                            : item.type === 7
                            ? _c("img", {
                                staticClass: "type6resouce",
                                attrs: { src: item.value }
                              })
                            : item.type === 10
                            ? _c(
                                "video",
                                {
                                  ref: "zl_edit_video" + index,
                                  refInFor: true,
                                  staticClass: "video-js type6resouce",
                                  attrs: {
                                    controls: "",
                                    preload: "auto",
                                    controlslist: "nodownload",
                                    "data-setup": "{'example_option':true}"
                                  }
                                },
                                [
                                  _c("source", {
                                    staticClass: "video",
                                    attrs: {
                                      src: item.value,
                                      type: "video/mp4"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "vjs-no-js" }, [
                                    _vm._v("不支持播放")
                                  ])
                                ]
                              )
                            : item.type === 11
                            ? _c("code-compiler", {
                                ref: "codeCompiler",
                                refInFor: true,
                                attrs: {
                                  readPage: "",
                                  readOnly: "",
                                  refresh: item.value
                                },
                                model: {
                                  value: item.value,
                                  callback: function($$v) {
                                    _vm.$set(item, "value", $$v)
                                  },
                                  expression: "item.value"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShow
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    "padding-right": "50px",
                                    "margin-top": "7px"
                                  }
                                },
                                [
                                  item.type === 11 &&
                                  item.extendOption &&
                                  item.extendOption.operationIsShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "btn",
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleGoStudy(item)
                                            }
                                          }
                                        },
                                        [_vm._v("试一下")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              )
            : _vm.currentValue.type == 7
            ? _c("img", {
                staticClass: "status_1_content_resouce contentItem",
                attrs: { src: _vm.currentValue.newAttaUrl }
              })
            : _vm.currentValue.type == 10
            ? _c(
                "video",
                {
                  ref: "newCourseVideo",
                  staticClass: "contentItem video-js status_1_content_resouce",
                  attrs: {
                    controls: "",
                    preload: "auto",
                    controlslist: "nodownload",
                    "data-setup": "{'example_option':true}"
                  }
                },
                [
                  _vm.currentValue.type == 10
                    ? _c("source", {
                        staticClass: "video",
                        attrs: {
                          src: _vm.currentValue.newAttaUrl,
                          type: "video/mp4"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "vjs-no-js" }, [_vm._v("不支持播放")])
                ]
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b798b6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b798b6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/zlItCourseEdit_show_status_1_content.vue
// module id = null
// module chunks = 